(function () {
  'use strict';
  var root = document.querySelector('.nose[data-api]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var camera = $('.nose__camera'), capture = $('.nose__capture'), upload = $('.nose__upload');
  var video = $('.nose__video'), photo = $('.nose__photo'), orb = $('.nose__orb');
  var query = $('.nose__query'), direction = $('.nose__direction'), find = $('.nose__find');
  var journey = $('.nose__journey'), timeline = $('.nose__timeline'), message = $('.nose__message');
  var journeyTitle = $('.nose__journey-title'), journeyPreview = $('.nose__journey-preview'), journeyPhoto = $('.nose__journey-photo');
  var results = $('.nose__results'), scan = $('.nose__scan');
  var stream = null, image = '', busy = false, followFrame = 0;
  function escape(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function motion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  function showProgress() { requestAnimationFrame(function () { journey.scrollIntoView({ behavior: motion(), block: 'start' }); }); }
  function showError(s) { cancelAnimationFrame(followFrame); journey.hidden = false; message.textContent = s; scan.hidden = true; busy = false; find.disabled = false; capture.disabled = false; showProgress(); }
  function stopCamera() { if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; } video.hidden = true; capture.hidden = true; }
  function resizeToJpeg(source, width, height) {
    var scale = Math.min(1, 1100 / Math.max(width, height));
    var canvas = document.createElement('canvas'); canvas.width = Math.round(width * scale); canvas.height = Math.round(height * scale);
    canvas.getContext('2d').drawImage(source, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpeg', .76);
  }
  function addStep(text) {
    var li = document.createElement('li'); li.textContent = text; timeline.appendChild(li);
    if (window.matchMedia && window.matchMedia('(max-width: 760px)').matches) {
      cancelAnimationFrame(followFrame);
      followFrame = requestAnimationFrame(function () {
        var bounds = journey.getBoundingClientRect();
        if (bounds.top < window.innerHeight && bounds.bottom > 0) li.scrollIntoView({ behavior: motion(), block: 'nearest' });
      });
    }
  }
  async function run(usingImage) {
    if (busy) return;
    var name = query.value.trim();
    if (!usingImage && name.length < 3) { showError('Enter the brand and perfume name, or show us a bottle.'); query.focus(); return; }
    busy = true; find.disabled = true; capture.disabled = true; results.hidden = true; results.textContent = '';
    journey.hidden = false; timeline.textContent = ''; message.textContent = ''; scan.hidden = !usingImage;
    journeyTitle.textContent = usingImage ? 'SCANNING YOUR BOTTLE' : 'FOLLOWING YOUR NOSE';
    journeyPreview.hidden = !usingImage;
    if (usingImage) { journeyPhoto.src = image; addStep('Bottle captured · starting the scan'); }
    else journeyPhoto.removeAttribute('src');
    showProgress();
    try {
      var response;
      try {
        response = await fetch(root.dataset.api, { method: 'POST', headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ query: usingImage ? '' : name, image: usingImage ? image : '', direction: direction.value.trim() }) });
      } catch (_) {
        throw new Error('The AI scent service cannot be reached yet. Your selection is still here; please try again after it launches.');
      }
      if (!response.ok) {
        var failed = await response.json().catch(function () { return {}; });
        throw new Error(failed.error || (response.status === 404 ? 'The AI scent service has not launched yet.' : 'The scent search could not start.'));
      }
      if (!response.body) throw new Error('Streaming is not available in this browser.');
      var reader = response.body.getReader(), decoder = new TextDecoder(), pending = '', finished = false;
      while (true) {
        var chunk = await reader.read(); if (chunk.done) break;
        pending += decoder.decode(chunk.value, { stream: true });
        var lines = pending.split('\n'); pending = lines.pop();
        lines.forEach(function (line) {
          if (!line) return;
          var event = JSON.parse(line);
          if (event.type === 'stage') addStep(event.label);
          if (event.type === 'identified') { addStep('Found ' + event.name); query.value = event.name; }
          if (event.type === 'researched') {
            addStep('Found ' + event.name + (event.family ? ' · ' + event.family : ''));
            if (event.top.length) addStep('The opening: ' + event.top.join(' · '));
            if (event.middle.length) addStep('The heart: ' + event.middle.join(' · '));
            if (event.base.length) addStep('The lasting notes: ' + event.base.join(' · '));
          }
          if (event.type === 'needs_name') { query.value = event.name || ''; image = ''; showError(event.message); query.focus(); finished = true; }
          if (event.type === 'no_match') { showError(event.message); finished = true; }
          if (event.type === 'error') { showError(event.message); finished = true; }
          if (event.type === 'result') { render(event); finished = true; }
        });
      }
      if (!finished) showError('The search ended before finding a result. Please try again.');
    } catch (err) { showError(err.message || 'The scent search is unavailable.'); }
    finally { scan.hidden = true; busy = false; find.disabled = false; capture.disabled = false; }
  }
  function render(data) {
    cancelAnimationFrame(followFrame);
    var match = data.matches[0];
    var notes = match.sharedNotes.map(function (n) { return '<span>' + escape(n) + '</span>'; }).join('');
    var secondary = data.matches.slice(1).map(function (m) { return '<a href="' + escape(m.url) + '">' + escape(m.title) + ' ↗</a>'; }).join('');
    var source = data.researched.sources[0];
    var price = new Intl.NumberFormat('en-PK').format(match.price);
    results.innerHTML = '<div class="nose__result-head"><small>THE NOSE MATCH</small><h2>Meet your next scent.</h2><p>Inspired by the published notes of ' + escape(data.researched.name) + '</p></div>' +
      '<div class="nose__card"><img src="' + escape(match.image || '') + '" alt="' + escape(match.title) + '" loading="lazy"><div>' +
      '<div class="nose__card-kicker">FULL-SIZE ELYSCENTS PERFUME</div><h3>' + escape(match.title) + '</h3>' +
      '<p>We found a similar scent direction through these shared published notes. It is its own fragrance, ready to wear your way.</p>' +
      '<div class="nose__chips">' + notes + '</div><div class="nose__price">Rs ' + price + '</div>' +
      '<div class="nose__card-actions"><button type="button" class="nose__button nose__button--primary nose__add" data-variant="' + escape(match.variantId) + '">Add to bag <span>→</span></button>' +
      '<a class="nose__shop" href="' + escape(match.url) + '">See the perfume ↗</a></div></div></div>' +
      (secondary ? '<div class="nose__other">Also close: ' + secondary + '</div>' : '') +
      '<p class="nose__source">Matched from published fragrance notes and stock checked at search time. ' +
      (source ? '<a href="' + escape(source.url) + '" target="_blank" rel="noopener noreferrer">View research ↗</a>' : '') + '</p>';
    results.hidden = false; message.textContent = ''; scan.hidden = true;
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  camera.addEventListener('click', async function () {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new Error('Camera is unavailable here. Upload a photo or type the name.');
      stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false });
      video.srcObject = stream; video.hidden = false; photo.hidden = true; orb.hidden = true; capture.hidden = false;
    } catch (err) { showError(err.message || 'Camera could not open. Upload a photo instead.'); }
  });
  capture.addEventListener('click', function () {
    if (!video.videoWidth) { showError('Camera is still starting. Try again in a moment.'); return; }
    image = resizeToJpeg(video, video.videoWidth, video.videoHeight);
    photo.src = image; photo.hidden = false; orb.hidden = true; stopCamera(); run(true);
  });
  upload.addEventListener('change', function () {
    var file = upload.files && upload.files[0]; if (!file) return;
    if (!file.type.startsWith('image/')) { showError('Choose a photo of a perfume bottle.'); return; }
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () { image = resizeToJpeg(img, img.naturalWidth, img.naturalHeight); URL.revokeObjectURL(url);
      photo.src = image; photo.hidden = false; orb.hidden = true; stopCamera(); run(true); };
    img.onerror = function () { URL.revokeObjectURL(url); showError('Could not open that image. Try a JPEG or PNG.'); };
    img.src = url;
  });
  find.addEventListener('click', function () { run(false); });
  query.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); run(false); } });
  results.addEventListener('click', async function (event) {
    var button = event.target.closest('.nose__add'); if (!button || button.disabled) return;
    button.disabled = true; button.textContent = 'Adding…';
    try {
      var path = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';
      var res = await fetch(path, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ id: Number(button.dataset.variant), quantity: 1 }) });
      if (!res.ok) throw new Error('This size may have just sold out. Open the perfume page to check.');
      window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
    } catch (err) { button.textContent = err.message || 'Could not add to bag'; button.disabled = false; }
  });
  window.addEventListener('pagehide', stopCamera);
})();
